import { WTVListParams } from './useWheelsTvVideosQuery';

export const wheelsTvKeys = {
  all: (params: WTVListParams) => ['WTV_LIST', params],
  filters: () => ['WTV_LIST_FILTERS'],
};
